/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { groupBy } from 'lodash';
import moment from 'moment';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
const uncheckedMark =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAbCAYAAAAdx42aAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAHZSURBVEhL7ZZZbwIxDIT7//8bAiHEJcSNuO/7dPVZbFWBkwaC4KXzMsRJllln7OyXfBimgOPxKJvNRvl8Pstut5P9fq9zMGPioet8MAVMp1MpFovK2+1WarWadLtdnYMZEw9d54MpYLFYSLVaVeYt2u22DAYDnYMZE/9rXb1el36/L6vVSmMWTAGXy0VOp5Ny8jtJJXw751q3XC6lUChIo9HQmAVTAIpbrZZXeQgOh4MMh0OZzWbXyD1MAePxWLLZrHIMyAJmxKQumALYNJ/Pfxz9LDAg6e/1etfIPUwBGApnwzFgf7PZVCO6YAoYjUaSyWSUY4AxST/mdMEUsF6vpdPpKMcAE1KOZNMFUwDmYXNSUs+CLlkqlfQYXDAFYMBKpaIcA1LPM3yZNAVQt+Vy2Vu/IUAAzYhMuGAKYCMO9pknBPwxL0JTc8FpQi6TWBPSR+gBk8nkGrmHKYDyS6fTLylDsugzsymA9NOGX9GIft+QFkwBlCBXLByD228EC6YAziyXy3nPLgSkniz47hRTAKXDJUI35CjIBI6mp8OMiSd9Ag5ZZ8EUkIAvmnw+r9XAvZ5KpZQZE2f+kXUWvALwAcfAhcJ58lCYMXHmH1lnwSvgHfgX8GEBIt8EVEx6Cv/eTAAAAABJRU5ErkJggg==';
export const checkMark =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAfCAYAAADwbH0HAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAQDSURBVEhL7VZJKK5tGH5TEmVYSCRlCCVSQhFFsZCFjUSRUBaGLLBQ2EgpiaysKDIlGYsdsqCMSabM8zzP0/V33f/3nl5fzve9p87pLP7/qrf7Ge7nuZ/nHq7nVfCX8L/h34bz83Nsb2/Lx7Yx/pjhubk59PX1yce2MX6b4dfXV7nZzMwM2tvbUVJSgry8PDQ2Nn5v+O3tDY+Pj6D8+PjA8/MzXl5eZJKSfY6b0nt6esLBwQHGx8dRX1+P1NRUxMXFISkpCc3NzVheXhY9LZSrqyusrKyAkhtsbW3h6OhIJinZ57gpvbW1NXR2diIzMxMxMTGIiIhAeXk5hoaGsLm5ibu7O9HTQrm9vZVJSt5if38fp6enMknJPse/06Pxvb09uVV2djaCg4MRFRWFnJwcDAwMyHrVK8ZQPj8/8f7+Dkq1TVcSlMZz2jYNDw4OiktdXV3h5+eH/Px8ifPJyYmsp+53UO7v7+XUlHpBV6+vr6OlpQUpKSkIDQ1FSEgIioqK0NvbK0lGHVNQLi4usLCwAEo94E0Z2+7ubmRlZcHBwQGBgYHIyMjA8PCwJJkeKIzBzc3NT2NhDB5wdHRUMjcgIAAuLi4oKChAT08PJiYmsLOzY9A0DYWJwkylVPHw8IDDw0MxwhDwliq4eUVFBXx9feHl5YX4+Hi0tbWJwY2NDYmtHiiMx/z8/Bda293dlVKYnp6WDbXxqq6uRlBQEGxtbREdHS0ZzTJjfZNEtIc0BYW3Y1wor6+vMTY2hpqaGiQnJwvz1NXVYXFxUb7+/n4kJibCzc1N3FxYWCjkQI/RKMuHbT1QmPJcRMnarK2tFdaxtraGo6MjIiMjhRyampokrt7e3nB2dpZ2V1eXYRsIq62uroq39EBhYrE0KLmYbmtoaEBsbCw8PDzg6ekpyZOeng53d3cxGhYWJofRGqGLuQc9pwcK3UvKo1QxOzuLyspKYSI7OzuEh4fD398fiqIISeTm5soaLWiY1MjD64HCBcxobVIcHx9jcnISCQkJsLCwgI2NDaysrMRwWlqalM7Z2ZlB+1/QIA9DMtIDSS4SgtZF3IRlwaeNMWW8LS0tJZPpCYbGmJnIAzzw5eWlYcQ0pJz4XmrLSUVra6tksZOTE+zt7eHj44OOjg7D7Feo/K3yvDkIgZAotASiYmRkBGVlZcLFfO5KS0sxNTVlmP0Krte+bOagsJT41FEagzFjPIuLi1FVVSUPvfoGG8P4jTYHhTEhOXwXG25Gb5C9SDIsl+8OSNDFvLVezldYAurGNMKN1eSiZJ/jNEpQ6tEzhx8/e/wNXVpakuxmqfAxp2Sf45z/FT1z+GGYcaa7SfZ0MTejZJ/jnP8VPXP4Y//V5vBfMwz8A98pV66XXgmUAAAAAElFTkSuQmCC';

const contentFont = 10;
const pageMargins = [42, 80, 28.8, 25.92];
const styles = {
  header: {
    fontSize: 18,
    bold: true,
    margin: [0, 0, 0, 10],
  },
  subheader: {
    fontSize: 16,
    bold: true,
    margin: [0, 10, 0, 5],
  },
  tableExample: {
    margin: [0, 5, 0, 15],
  },
  tableHeader: {
    bold: true,
    fontSize: 13,
    color: 'black',
  },
};

const amountFormatter = (value) => {
  if (value < 0) {
    return `($${value
      .toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      })
      .substring(2)})`;
  }
  if (value) {
    return `$ ${value
      .toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      })
      .substring(1)}`;
  }
  return '';
};

const numberFormatter = (value) => {
  if (value < 0) {
    return `(${parseFloat(value)?.toLocaleString('en-US').substring(1)})`;
  }
  return parseFloat(value)?.toLocaleString('en-US');
};
const getHeader = (currentPage, pageCount, data, options) => {
  const { prinDate, requestedBy, reportName, manufacturer } = data;

  const { info } = options;
  const {
    firstInfo = '',
    thirdInfo = '',     // NMFD – New Mexico Medicaid
    fourthInfo = '',    // Report Quarter
    fifthInfo = '',
  } = info;

  const widths = ['35%', '30%', '35%'];

  return {
    margin: [42, 20, 28.8, 40],
    table: {
      widths,
      body: [
        // ───── Row 1 ─────
        [
          {
            text: [{ text: 'Requested By: ', bold: true }, requestedBy],
            alignment: 'left',
            fontSize: 10,
          },
          {
            text: reportName,
            alignment: 'center',
            fontSize: 12,
            bold: true,
          },
          {
            text: [{ text: 'Date Printed: ', bold: true }, prinDate],
            alignment: 'right',
            fontSize: 10,
          },
        ],

        // ───── Row 2 (NMFD restored) ─────
        [
          { text: '' },
          {
            text: thirdInfo,
            alignment: 'center',
            fontSize: 10,
            bold: true,
          },
          {
            text: `Page ${currentPage} of ${pageCount}`,
            alignment: 'right',
            fontSize: 10,
          },
        ],

        // ───── Row 3 (Report Quarter) ─────
        [
          { text: '' },
          {
            text: fourthInfo,
            alignment: 'center',
            fontSize: 10,
            bold: true,
          },
          { text: '' },
        ],

        // ───── Row 4 (Manufacturer centered) ─────
        [
          {
            text: firstInfo,
            alignment: 'left',
            fontSize: 10,
            bold: true,
          },
          {
            text: `Manufacturer: ${manufacturer}`,
            alignment: 'center',
            fontSize: 10,
            bold: true,
          },
          {
            text: fifthInfo,
            alignment: 'right',
            fontSize: 10,
            bold: true,
          },
        ],
      ],
    },
    layout: 'noBorders',
  };
};



const getTableBodyData = (data, cols, paginationArr, options = {}) => {
  const { globalTotalAmountInDispute, isLastPage } = options;

  const dataToReturn = [];
  let manufacturerTotal = 0;

  dataToReturn.push(
    cols.map((col) => ({
      text: col.headerName,
      bold: true,
      fontSize: contentFont,
      border: [true, true, true, true],
      alignment: col.alignment || 'left',
    }))
  );

  const groupedByQtrData = groupBy(data, 'qtr');
  let dataWithTotal = [];

  for (const key in groupedByQtrData) {
    const oneQtrData = groupedByQtrData[key];
    let totalRow = { ...oneQtrData[0] };
for (let i = 0; i < oneQtrData.length; i += 1) {
  if (i !== 0) {
    totalRow.amt_IN_DISP += oneQtrData[i].amt_IN_DISP || 0;
    totalRow.totCurrQtrAmt += oneQtrData[i].totCurrQtrAmt || 0;
    totalRow.curr_AMT_DISP_DRUGS += oneQtrData[i].curr_AMT_DISP_DRUGS || 0;

    oneQtrData[i].qtr = '';
  }

  oneQtrData[i].totCurrQtrAmt = '';
  oneQtrData[i].pct_DISP_OF_TOT_INVOICE = '';
  oneQtrData[i].curr_AMT_DISP_DRUGS = '';
  oneQtrData[i].pct_DISP_OF_DISP_DRUGS = '';
  oneQtrData[i].c_TOT = '';
}


    totalRow.pct_DISP_OF_TOT_INVOICE = `${(
      (totalRow.amt_IN_DISP / (totalRow.c_TOT || 1)) *
      100
    ).toFixed(4)} %`;

    totalRow.pct_DISP_OF_DISP_DRUGS = `${(
      (totalRow.amt_IN_DISP /
        (totalRow.curr_AMT_DISP_DRUGS || 1)) *
      100
    ).toFixed(4)} %`;

    totalRow.isTotal = true;
    totalRow.drugName = 'Quarter Total:';
    totalRow.qtr = '';
    totalRow.ndc = '';
    totalRow.disputeCodes = '';

    manufacturerTotal += parseFloat(totalRow.amt_IN_DISP || 0);

    oneQtrData.push(totalRow);
    dataWithTotal.push(...oneQtrData);
  }

  dataWithTotal.push({
    drugName: 'Manufacturer Total:',
    amt_IN_DISP: manufacturerTotal,
    isManufacturerTotal: true,
  });

  if (isLastPage) {
    dataWithTotal.push({
      drugName: 'Total Amount in Dispute:',
      amt_IN_DISP: globalTotalAmountInDispute,
      isGrandTotal: true,
    });
  }

  dataWithTotal.forEach((row) => {
    const tempCols = [];

    cols.forEach((col, idx) => {
      let text = row[col.field] || '';

      if (col.isAmount) {
        text = amountFormatter(row[col.field]);
      }

      tempCols.push({
        text,
        bold: row.isTotal || row.isManufacturerTotal || row.isGrandTotal || idx === 0,
        alignment:
          row.isTotal || row.isManufacturerTotal || row.isGrandTotal
            ? 'right'
            : col.alignment || 'left',
        fontSize: contentFont,
        border: [true, true, true, true],
      });
    });

    dataToReturn.push(tempCols);
  });

  return dataToReturn;
};
const getTableBody = (data, cols, paginationArr, colWidths, options) => {
  const body = [];
  const { titleName = '', mapping = {} } = options;
  const dataKeys = paginationArr.length > 0 ? paginationArr : Object.keys(data);
  const widths =
    colWidths?.length > 0
      ? colWidths
      : cols.map((item) => (item.field === 'drugName' ? 200 : '*'));
  for (let i = 0; i < dataKeys.length; i += 1) {
body.push({
  table: {
    widths: ['*', '*', '*'], 
    body: [
      [
        {
          text: [
            { text: titleName, bold: true, fontSize: contentFont },
            { text: mapping[dataKeys[i]] || dataKeys[i], fontSize: contentFont },
          ],
          alignment: 'left',
        },
        {
          text: (options?.ninethInfo || ''),
          bold: true,
          fontSize: contentFont,
          alignment: 'center',
          margin: [0, -16, 0, 8],
        },

        {
          text: options?.useBalanceThreshold
            ? 'Use Report Balance Due Threshold'
            : '',
          bold: true,
          fontSize: contentFont,
          alignment: 'right', 
        },
      ],
    ],
  },
  layout: 'noBorders',
  margin: [0, 6, 0, 6],
});




    body.push({
      style: 'tableExample',
      table: {
        widths: ['*'],
        body: [
          [
            {
              table: {
                headerRows: 1,
                widths,
                body: getTableBodyData(
                  data[dataKeys[i]],
                  cols,
                  paginationArr,
                  {
                    ...options,
                    isLastPage: i === dataKeys.length - 1,
                  }
                ),
              },
            },
          ],
        ],
      },
      layout: 'noBorders',
    });

    if (i < dataKeys.length - 1) {
      body.push({
        text: '',
        pageBreak: 'before',
      });
    }
  }

  return body;
};


/**
 * Download as PDF with all Data.
 * @param {object} headerData - conatisn header info of PDF.
 * @param {object} bodyData - constains Body data for PDF.
 */
const getPdfData = (
  bodyData,
  columns,
  headerData,
  paginationArr,
  widths,
  options
) => {
  const { pageSize } = options;
  const content = getTableBody(
    bodyData,
    columns,
    paginationArr,
    widths,
    options
  );
  const currentYear = new Date().getFullYear();
  let docDefinition = {
    header: (currentPage, pageCount) => {
      return getHeader(currentPage, pageCount, headerData, options);
    },
    footer: () => {
        const footers = [];
        footers.push({
          text:`${currentYear} Conduent Business Services, LLC. All rights reserved. Conduent and Conduent Agile Star are trademarks of Conduent Business Services, LLC in the United States and/or other countries.`,
          fontSize: 8,
          color: '#636363',
          fontFamily: 'Arial',
          alignment: 'center',
        });

      return footers;
    },
    content,
    pageMargins,
    styles,
    pageOrientation: 'landscape',
  };

  if (pageSize && pageSize?.width && pageSize.height) {
    docDefinition = {
      ...docDefinition,
      pageSize: {
        width: pageSize.width,
        height: pageSize.height,
      },
    };
  }
  return docDefinition;
};

/**
 * Download as PDF with all Data.
 * @param {object} data - header info of PDF.
 * @param {object} userDefaultValues - use info containg object
 */
const getHeaderData = (data, UserDefaultsValues, logInUser) => {
  const { reportName, manufacturer } = data;

  return {
    prinDate: moment(new Date()).format('MM/DD/YYYY'),
    requestedBy:
      UserDefaultsValues && UserDefaultsValues.userId
        ? UserDefaultsValues.userId
        : logInUser,
    reportName,
    manufacturer,
  };
};


/**
 * Download as PDF with all Data.
 * @param {object} header - header info of PDF.
 * @param {object} bodyData - All the data for the PDF.
 * @param {object} userDefaultValues
 */
export const exportAllPDF = (
  header,
  bodyData,
  columns,
  userDefaultValues,
  options = {},
  paginationArr = [],
  widths,
  logInUser
) => {
  const headerData = getHeaderData(header, userDefaultValues, logInUser);

  const pdfData = getPdfData(
    bodyData,
    columns,
    headerData,
    paginationArr,
    widths,
    options
  );
  pdfMake
    .createPdf(pdfData)
    .download(
      `${header.fileName ? header.fileName : header?.reportName || 'data'}.pdf`
    );
};
